import { ArrowIcon } from "@/assets/icons";
import style from "./StylesLabel.module.scss";
import clsx from "clsx";
import { useEffect, useRef } from "react";
import useEffectStore from "@/stores/effectStore";
import { getI18nLang } from "@/utils";
import { I18nLangMap } from "@/constants";
import { useTranslation } from "react-i18next";
export const aigc_click_record = "aigc_click_record";

interface PropsType {
  isMobile?: boolean;
  className?: string;
  onChange?: (state: string) => void;
  gap?: number;
}

const FTStyleLableList = (props: PropsType) => {
  const { className = "", isMobile = false, onChange, gap } = props;
  const swiperDom = useRef<any>(null);
  const { t, i18n } = useTranslation();
  const labelId = useEffectStore((state) => state.selectObj.lable.id);
  const setChooseInfo = useEffectStore((state) => state.setChooseInfo);

  const list = useEffectStore((state) => state.labelListObj.arr);
  const loading = useEffectStore((state) => state.labelListObj.loading);

  const scrollDoms = useRef<any>(null);
  /**记录滚动那个 */
  const curIndex = useRef(-1);
  function handel_scroll(indexs: number) {
    try {
      curIndex.current = indexs;
      // 这里可能会出现特殊字符 ，导致无法选中的情况
      // const doms = scrollDoms.current.querySelectorAll(
      //   `.${style["lable-inner-class"]}`
      // )[indexs] as HTMLDivElement;
      const doms = scrollDoms.current.querySelectorAll(`.lable-inner-class`)[
        indexs
      ] as HTMLDivElement;
      const { left } = swiperDom.current.getBoundingClientRect();
      const { width: width1, left: left1 } = doms.getBoundingClientRect();
      let borderValues = left1 - left;
      let borderAllValues = borderValues + width1;
      if (borderAllValues > swiperDom.current.offsetWidth) {
        if (!isMobile) {
          watchTraslate.current =
            mouseObj.current.origin +
            swiperDom.current.offsetWidth -
            borderAllValues -
            60;
          let tra = -(
            scrollDoms.current.offsetWidth - swiperDom.current.offsetWidth
          );
          if (watchTraslate.current < tra) {
            watchTraslate.current = tra;
          }
          scrollDoms.current.style.cssText = `transform:translate3d(${watchTraslate.current}px,0,0);`;
          mouseObj.current.origin = watchTraslate.current;
        } else {
          watchTraslate.current =
            scrollDoms.current.scrollLeft +
            borderAllValues -
            scrollDoms.current.offsetWidth +
            60;
          scrollDoms.current.scrollTo({
            left: watchTraslate.current,
            top: 0,
            behavior: "smooth",
          });
        }
      } else if (borderValues < 0) {
        if (!isMobile) {
          watchTraslate.current =
            mouseObj.current.origin + Math.abs(borderValues) + 20;
          if (watchTraslate.current > 0) {
            watchTraslate.current = 0;
          }

          scrollDoms.current.style.cssText = `transform:translate3d(${watchTraslate.current}px,0,0);`;
          mouseObj.current.origin = watchTraslate.current;
        } else {
          watchTraslate.current =
            scrollDoms.current.scrollLeft + borderValues - 20 <= 0
              ? 0
              : scrollDoms.current.scrollLeft + borderValues - 20;
          scrollDoms.current.scrollTo({
            left: watchTraslate.current,
            top: 0,
            behavior: "smooth",
          });
        }
      }
    } catch {}
  }

  useEffect(() => {
    if (loading) {
      return;
    }
    let lastWidth = 0;
    function resize(entries: ResizeObserverEntry[]) {
      for (let entry of entries) {
        const width = entry.contentRect.width;
        //检测宽度变化
        if (width !== lastWidth) {
          //说明不会由滚动条
          if (swiperDom.current.offsetWidth >= scrollDoms.current.offsetWidth) {
            mouseObj.current.origin = 0;
            scrollDoms.current.style.transition = `unset`;
            scrollDoms.current.style.transform = `translate3d(${0}px,0,0)`;
            watchTraslate.current = 0;
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                handel_translate();
                handel_scroll(curIndex.current);
              });
            });
          }
          //一定由滚动条
          else {
            let tra = -(
              scrollDoms.current.offsetWidth - swiperDom.current.offsetWidth
            );
            if (mouseObj.current.origin < tra) {
              mouseObj.current.origin = tra;
              watchTraslate.current = tra;
              scrollDoms.current.style.transition = `unset`;
              scrollDoms.current.style.transform = `translate3d(${tra}px,0,0)`;
              requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                  handel_translate();
                  handel_scroll(curIndex.current);
                });
              });
            }
          }

          lastWidth = width;
        }
      }
    }
    let doms = new ResizeObserver(resize);
    doms.observe(scrollDoms.current);
    return () => {
      doms.disconnect();
    };
  }, [loading]);

  const watchTraslate = useRef(0);
  const leftDom = useRef<any>(null);
  const rightDom = useRef<any>(null);
  const mouseObj = useRef({
    x: 0,
    y: 0,
    status: "",
    origin: 0,
    translate: 0,
  });

  function handel_mouse_move(el: MouseEvent) {
    requestAnimationFrame(() => {
      try {
        if (mouseObj.current.status === "end") {
          return;
        }
        if (mouseObj.current.status !== "move") {
          mouseObj.current.status = "move";
          scrollDoms.current.style.transition = `unset`;
        }

        let tra = -(
          scrollDoms.current.offsetWidth - swiperDom.current.offsetWidth
        );
        //当前平移距离
        let values = el.pageX - mouseObj.current.x;
        let base = mouseObj.current.origin + values;
        if (base > 0) {
          base = 0;
        }
        if (base < tra) {
          base = tra;
        }
        //实际平移距离
        mouseObj.current.translate = -(
          Math.abs(base) - Math.abs(mouseObj.current.origin)
        );

        watchTraslate.current = base;
        scrollDoms.current.style.transform = `translate3d(${base}px,0,0)`;
      } catch {}
    });
  }
  function handel_mouse_up() {
    try {
      mouseObj.current.origin += mouseObj.current.translate;
      mouseObj.current.status = "end";
      window.removeEventListener("mousemove", handel_mouse_move);
      window.removeEventListener("pointerup", handel_mouse_up);
      scrollDoms.current.style.transition = `all 0.2s linear`;
    } catch {}
  }

  function handel_translate() {
    requestAnimationFrame(() => {
      try {
        if (watchTraslate.current >= 0) {
          leftDom.current.style.display = "none";
        } else {
          leftDom.current.style.display = "flex";
        }
        let tra = -(
          scrollDoms.current.offsetWidth - swiperDom.current.offsetWidth
        );
        if (watchTraslate.current <= tra) {
          rightDom.current.style.display = "none";
        } else if (
          scrollDoms.current.offsetWidth > swiperDom.current.offsetWidth
        ) {
          rightDom.current.style.display = "flex";
        }
      } catch {}
    });
  }
  useEffect(() => {
    if (loading) {
      return;
    }
    const observer = new MutationObserver(handel_translate);
    try {
      const config = { attributes: true };
      observer.observe(scrollDoms.current, config);
      handel_translate();
    } catch {}
    return () => {
      observer.disconnect();
    };
  }, [loading]);

  const timer = useRef<NodeJS.Timeout>();
  useEffect(() => {
    if (list.length === 0) {
      return;
    }
    try {
      let index = list.findIndex((items) => items.id === labelId);
      clearTimeout(timer.current);
      timer.current = setTimeout(() => {
        handel_scroll(index);
      }, 50);
    } catch {}
  }, [labelId, list]);

  return (
    <div
      ref={swiperDom}
      className={clsx(style["style-lable"], className && className)}
    >
      {!loading && (
        <>
          <div
            onClick={() => {
              try {
                mouseObj.current.origin += Math.floor(
                  swiperDom.current.offsetWidth / 2
                );
                if (mouseObj.current.origin > 0) {
                  mouseObj.current.origin = 0;
                }
                scrollDoms.current.style.transform = `translate3d(${mouseObj.current.origin}px,0,0)`;
                watchTraslate.current = mouseObj.current.origin;
              } catch {}
            }}
            ref={leftDom}
            className={style["left"]}
          >
            <ArrowIcon width={24} />
          </div>
          <div
            onClick={() => {
              try {
                mouseObj.current.origin -= Math.floor(
                  swiperDom.current.offsetWidth / 2
                );
                let tra = -(
                  scrollDoms.current.offsetWidth - swiperDom.current.offsetWidth
                );
                if (mouseObj.current.origin < tra) {
                  mouseObj.current.origin = tra;
                }
                scrollDoms.current.style.transform = `translate3d(${mouseObj.current.origin}px,0,0)`;
                watchTraslate.current = mouseObj.current.origin;
              } catch {}
            }}
            ref={rightDom}
            className={style["right"]}
          >
            <ArrowIcon width={24} />
          </div>
          <div
            onPointerDown={(el) => {
              if (mouseObj.current.status === "down" || isMobile) {
                return;
              }
              if (
                scrollDoms.current.offsetWidth <= swiperDom.current.offsetWidth
              ) {
                return;
              }
              mouseObj.current = {
                status: "down",
                x: el.pageX,
                y: el.pageY,
                translate: 0,
                origin: mouseObj.current.origin,
              };
              window.addEventListener("mousemove", handel_mouse_move);
              window.addEventListener("pointerup", handel_mouse_up);
            }}
            ref={scrollDoms}
            className={clsx(
              style["lable-container"],
              isMobile && style["lable-container-moible"]
            )}
          >
            {gap && (
              <div
                style={{
                  width: gap + "px",
                  height: "100%",
                  display: "inline-block",
                }}
              ></div>
            )}

            {list?.map((item, indexs) => {
              return (
                <div
                  onPointerUp={() => {
                    if (
                      mouseObj.current.translate !== 0 &&
                      Math.abs(Math.floor(mouseObj.current.translate)) >= 3
                    ) {
                      return;
                    }
                    setChooseInfo(1, { name: "aaa", id: item.id });
                    useEffectStore.getState().getEffectList();
                    // handel_scroll(indexs);
                  }}
                  key={item.id}
                  className={clsx(
                    style["lable-inner-class"],
                    labelId === item.id && style["lable-inner-class-active"],
                    "lable-inner-class"
                  )}
                >
                  {getI18nLang(item.i18nAttr, I18nLangMap[i18n.language]) ||
                    item.title}
                </div>
              );
            })}
            {gap && (
              <div
                style={{
                  width: gap + "px",
                  height: "100%",
                  display: "inline-block",
                }}
              ></div>
            )}
          </div>
        </>
      )}
      {loading && (
        <div className={style["loading-fra"]}>
          {[1, 2, 3, 4].map((items) => {
            return (
              <div
                className={clsx(style["loading-lable"], "skeleton_loading")}
                key={items}
              ></div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default FTStyleLableList;
